import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full bg-background min-h-screen" }
const _hoisted_2 = { class: "flex flex-col container" }
const _hoisted_3 = { class: "flex flex-row justify-between py-5" }
const _hoisted_4 = { class: "flex flex-row w-1/4 items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M11 17l-5-5m0 0l5-5m-5 5h12"
  })
], -1)
const _hoisted_6 = { class: "flex flex-row w-3/4 bg-purple-100 justify-between py-4 px-3 items-center rounded-full" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold pl-4" }, " You’re generating a new template from scratch ", -1)
const _hoisted_8 = { class: "flex flex-row space-x-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CreateTalentEvaluationForm = _resolveComponent("CreateTalentEvaluationForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _createVNode(_component_Button, {
                label: "Back",
                variant: "outlined",
                onOnClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.router && _ctx.router?.push('/talent-evaluation')))
              }, {
                startIcon: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_Button, {
                label: "Save as a Draft",
                variant: ""
              }, {
                startIcon: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_Button, {
                label: "Submit new template",
                variant: "contained",
                onOnClick: _ctx.submitData,
                disabled: 
                (_ctx.formRef && !_ctx.formRef?.meta.dirty) ||
                (_ctx.formRef && !_ctx.formRef?.meta.valid)
              
              }, null, 8, ["onOnClick", "disabled"])
            ])
          ])
        ]),
        _createVNode(_component_CreateTalentEvaluationForm, {
          ref: "formRef",
          onSubmitData: _ctx.submitData
        }, null, 8, ["onSubmitData"])
      ])
    ])
  ], 64))
}